let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hBYt2")).then(() => parcelRequire('k6mJI'));